<!-- 模板编辑填写 -->
<template>
    <div class="templateEdit">
        <el-row style="background-color: white;position: fixed;padding: 10px;top: 70px;right: 50px;z-index: 100;width: calc(100% - 400px);text-align: center;" v-if="toolShow && !$isEmpty(htmlInfo) && templateType == 2">
            <template v-if="dataInfo.studentTemplateExamineStatus == 3">
                <el-button style="color: red;font-weight: bold;" @click="seeRemark">审核未通过【查看原因】</el-button>
            </template>
            <template v-if="dataInfo.studentTemplateExamineStatus != 1">
                <el-button class="but" type="primary" v-if="showInfo.edit && currentType == 1 && isEdit" @click="editNow" plain icon="el-icon-edit">编辑</el-button>
            </template>
            <el-button class="but" type="primary" v-if="showInfo.print && currentType == 1" @click="printNow" plain icon="el-icon-printer">打印</el-button>
            <el-button class="but" type="primary" v-if="showInfo.down && currentType == 1" @click="downloadNow" plain icon="el-icon-download">导出</el-button>
            <el-button class="but" type="primary" v-if="currentType == 2" @click="getInfo" plain icon="el-icon-view">预览</el-button>
            <template v-for="(item,index) in signList">
                <el-button class="but" type="primary" v-if="showInfo.save && currentType == 2" @click="singShow(item)" plain icon="el-icon-edit">本人签名</el-button>
            </template>
            <el-button class="but" type="primary" v-if="showInfo.save && currentType == 2" @click="saveInfo" plain icon="el-icon-suitcase">保存</el-button>
        </el-row>
        <el-row style="text-align:right;" v-if="toolShow && templateType == 1">
            <el-button class="but" type="primary" v-if="showInfo.print && currentType == 1 && !this.$strExistHostnameOnce(['jlaudev'])" @click="printNowImg" plain icon="el-icon-printer">打印</el-button>
            <el-button class="but" type="primary" v-if="showInfo.down && currentType == 1" @click="downImg" plain icon="el-icon-download">下载</el-button>
        </el-row>
        <template v-if="templateType == 1">
            <el-row style="max-width: 800px;text-align: center;margin: 0 auto;">
                <div id='printBill_img'>
                    <template v-for='(item,index) in imgUrlList'>
                        <img width="100%" :key="index+'imgUrlList'" :src="$isHttp(item)" alt="" style="vertical-align:top">
                        <div style="page-break-after:always;"></div>
                    </template>
                </div>
            </el-row>
        </template>
        <template v-if="templateType == 2">
            <div style="margin: 0 auto;width: 1060px;height: auto;margin-bottom: 300px;">
                <div id='printBill' ref="printContent" v-html="htmlInfo">

                </div>
            </div>
        </template>
        <el-dialog title="签名方式" :visible.sync="visible" width="800px" >
            <div style="text-align: center;padding-bottom: 50px;">
                <el-button type="primary" @click="signStart" plain icon="el-icon-monitor">电脑鼠标签名</el-button>
                <el-button type="primary" @click="creatQRCode" plain icon="el-icon-mobile-phone">手机扫码签名</el-button>
            </div>
        </el-dialog>

        <el-dialog title="" :visible.sync="visible_qRcode" width="300px" :close-on-click-modal="false">
            <div style="text-align: center;padding-bottom: 20px;">
                <p style="font-size: 12px;margin-top: 0;">请打开手机浏览器扫描下方二维码进行签名</p>
                <img :src="qRcodeImg" style="height: 200px;width: 200px;" />
                <el-button type="primary" :loading="signLoading" @click="getSignInfo" icon="el-icon-mobile-phone">我已签名，获取我的签名</el-button>
            </div>
        </el-dialog>
        <!-- 签名 -->
        <singDiv v-if="visible_sign" :visible="visible_sign" @closeMsg="closeMsg" @signValue="saveSignValue"></singDiv>
    </div>
</template>
<script>
import {getStorageKeyForRoleTag,getCookieForRoleTag} from "../common/ulit";
import jQuery, { data } from 'jquery';
import store from "@/store/index";
import dateTime from '../static/date/dateTime.min.js' //注意路径
import html2canvas from 'html2canvas';
import printJS from 'print-js';
import jquery from "jquery";
import singDiv from "@/components/singDiv"; //签名
export default {
    name: 'TemplateEdit',
    components: {
        singDiv
    },
    props: {
        templateName: { //模板名称
            type: String,
            default: ""
        },
        toolShow:{ //是否显示头部工具栏
            type: Boolean,
            default: false
        },
        showInfo:{ //按钮功能是否显示
            type: Object,
            default: function () {
                return {
                    edit:true,
                    print:true,
                    down:true,
                    save:true,
                }
            }
        }
    },
    data() {
        return {
            uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
            studentInfo:{},//学生信息
            htmlInfo:null, //表格信息html
            attributeList:{}, //属性map,
            templateId:null, //模板ID
            allInputType4:{}, //用于存所有联动数据，格式{attributeId:[]}
            getParamKey:{}, //用于获取填写数据 格式{属性ID:类型}
            currentType:1, // 1:预览 2:编辑
            isEdit:false, //是否能够编辑 1：可预览 2：可预览可编辑可编辑
            templateType:null,//1:图片 2：表格
            imgUrlList:[], //图片类型List
            dataInfo:{},
            signList:[],

            visible:false, //选择签名方式
            visible_sign:false, //显示PC签名
            onAttributeId:"",
            visible_qRcode:false,
            qRcodeImg:"",
            signLoading:false
        }
    },
    created() {
        this.studentInfo = JSON.parse(sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag()));
        this.getTemplateByName();
    },
    methods:{
        editNow(){  //编辑
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            this.attributeList = {}; //属性map,
            this.$store.dispatch("user/getCanEditTemplateSingle",{templateName:this.templateName}).then((ret) => {
                loading.close();
                if(ret.code == 0){
                    this.currentType = 2;
                    this.htmlInfo = ret.data.templateHtml; //表格信息html
                    //attributeList是数组，转换成自己想要的map类型
                    if(!this.$isEmpty(ret.data.attributeList) && ret.data.attributeList.length > 0){
                        for(let index in ret.data.attributeList){
                            this.attributeList[ret.data.attributeList[index].attributeName] = ret.data.attributeList[index]; //属性map,
                        }
                    }
                    this.templateId = ret.data.templateId; //模板ID

                    this.setShowValue();
                }else{
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
                loading.close();
            });
        },
        setShowValue(){ //将html中的可填写数据转换成相应的下拉或者填写框
            //inputType：1单选 2多选 3输入 4多级联动  5上传图片 6上传附件 7多行输入 8日期 9签名

            //获取所有{}中的数据
            var regex3 = /\{(.+?)\}/g;  // {} 花括号，大括号
            let editArray = this.htmlInfo.match(regex3); //{}中的数据数组
            this.signList = [];
            for(let i in editArray){
                let one = editArray[i].indexOf(".");
                let two = editArray[i].indexOf("@");
                let attributeName = editArray[i].slice(one + 1,two); //截取字符串，获取属性名称
                //根据属性名获取相应的属性数据，判断属于什么编辑类型
                let attributeInfo = this.attributeList[attributeName]; //属性数据
                if(this.$isEmpty(attributeInfo)){
                    continue;
                }
                this.getParamKey[attributeInfo.attributeId] = attributeInfo.inputType; //用于获取填写数据
                if(attributeInfo.inputType == 1){ //单选类型
                    let htm = "<option value=''>请选择</option>";
                    let vList = attributeInfo.attributeValues.replace(/\r/g,"").split("\n");
                    for(let inx in vList){
                        if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value) && attributeInfo.attributeRelation.value == vList[inx]){
                            htm += "<option selected value='"+vList[inx]+"'>"+vList[inx]+"</option>";
                        }else{
                            htm += "<option value='"+vList[inx]+"'>"+vList[inx]+"</option>";
                        }
                    }
                    htm = "<div class='select'><select class='attrEditInfo1' notNullStatus='"+attributeInfo.notNullStatus+"' name='"+attributeInfo.attributeId+"' title='请选择"+attributeName+"' placeholder='"+(attributeInfo.desc || "请选择"+attributeName)+"' >"+htm+"</select></div>";
                    this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                }else if(attributeInfo.inputType == 2){ //多选类型
                    let htm = "";
                    let vList = attributeInfo.attributeValues.replace(/\r/g,"").split("\n");
                    let relationVal = "";
                    if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                        relationVal = attributeInfo.attributeRelation.value; //选中的值，分割
                    }
                    for(let inx in vList){
                        if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value) && (','+relationVal+',').indexOf(','+vList[inx]+',') >= 0){
                            htm += "<span class='checkboxClass'><input class='attrEditInfo2' title='请选择"+attributeName+"' placeholder='"+(attributeInfo.desc || "请选择"+attributeName)+"' notNullStatus='"+attributeInfo.notNullStatus+"'  type='checkbox' checked value='"+vList[inx]+"' name='"+attributeInfo.attributeId+"' id='che_"+attributeInfo.attributeId+'_'+inx+"' /><label for='che_"+attributeInfo.attributeId+'_'+inx+"'>"+vList[inx]+"</label></span>";
                        }else{
                            htm += "<span class='checkboxClass'><input class='attrEditInfo2' title='请选择"+attributeName+"' placeholder='"+(attributeInfo.desc || "请选择"+attributeName)+"' notNullStatus='"+attributeInfo.notNullStatus+"'  type='checkbox' value='"+vList[inx]+"' name='"+attributeInfo.attributeId+"' id='che_"+attributeInfo.attributeId+'_'+inx+"' /><label for='che_"+attributeInfo.attributeId+'_'+inx+"'>"+vList[inx]+"</label></span>";
                        }
                    }
                    this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                }else if(attributeInfo.inputType == 3){ //输入类型
                    let htm = "";
                    let limitCondition = {minNumber:null,maxNumber:null};
                    if(attributeInfo.limitCondition != null && attributeInfo.limitCondition != ""){
                        limitCondition = JSON.parse(attributeInfo.limitCondition);
                        if(limitCondition.minNumber == 0){
                            limitCondition.minNumber = null;
                        }
                        if(limitCondition.maxNumber == 0){
                            limitCondition.minNumber = null;
                        }
                    }
                    if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                        htm = "<input class='attrEditInfo3 inputClass' minlength='"+limitCondition.minNumber+"' maxlength='"+limitCondition.maxNumber+"' notNullStatus='"+attributeInfo.notNullStatus+"' title='请输入"+attributeName+"' placeholder='"+(attributeInfo.desc || "请输入"+attributeName)+"' name='"+attributeInfo.attributeId+"' value='"+attributeInfo.attributeRelation.value+"' />";
                    }else{
                        htm = "<input class='attrEditInfo3 inputClass' minlength='"+limitCondition.minNumber+"' maxlength='"+limitCondition.maxNumber+"' notNullStatus='"+attributeInfo.notNullStatus+"' title='请输入"+attributeName+"' placeholder='"+(attributeInfo.desc || "请输入"+attributeName)+"' name='"+attributeInfo.attributeId+"' />";
                    }
                    this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                }else if(attributeInfo.inputType == 4){ //多级联动类型
                    let htm = "";
                    let relationVal = "";
                    if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                        relationVal = attributeInfo.attributeRelation.value; //选中的字|||分割
                    }
                    // let relationVal = "广东省|||深圳市"; //选中的字|||分割
                    this.$store.dispatch("user/getAttrTreeById",{attributeId:attributeInfo.attributeId}).then((ret) => {
                        if(ret.code == 0){
                            this.allInputType4[attributeInfo.attributeId] = ret.data.children;
                            if(!this.$isEmpty(ret.data) && !this.$isEmpty(ret.data.children)){
                                let chList = ret.data.children;
                                // for(let j in chList){
                                //     this.allInputType4[attributeInfo.attributeId][chList[j].attributeName] = chList[j];
                                // }
                                htm += this.getErgodicInfo(chList,relationVal,attributeInfo.attributeId,"",editArray[i]);
                                // htm += this.getErgodicInfo(chList,null,attributeInfo.attributeId,"",editArray[i]);
                            }
                        }else{
                            this.$message.error(ret.msg);
                            this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                        }
                    }).catch((err) => {
                        this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                    });
                }else if(attributeInfo.inputType == 5){ //上传图片
                    let htm = "";
                    if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                        htm = "<img class='img"+attributeInfo.attributeId+"' style='width: 90%;height: auto;margin:0 auto;display:block;' src='"+this.$isHttp(attributeInfo.attributeRelation.value)+"' />";
                        htm += '<div class="attributeInfoImg attributeInfoImg'+attributeInfo.attributeId+'" style="display:none;"><label title="上传'+attributeInfo.attributeName+'" class="lee-upload-fileicon l-icon-upload-big" for="fileId'+attributeInfo.attributeId+'">'+
                        '<i class="el-icon-circle-plus-outline" style=""></i><br/>上传图片'+
                        '</label><input type="file" id="fileId'+attributeInfo.attributeId+'" class="avatar-input">'+
                        '<input type="hidden" name="'+attributeInfo.attributeId+'" value="'+attributeInfo.attributeRelation.value+'"></div>';
                        setTimeout(function(){
                            var setNull = null;
                            jQuery('.img'+attributeInfo.attributeId).hover(function(){
                                if(setNull != null){
                                   clearTimeout(setNull);
                                }
                                jQuery('.attributeInfoImg'+attributeInfo.attributeId).show();
                            },function(){
                                setNull = setTimeout(function(){
                                    jQuery('.attributeInfoImg'+attributeInfo.attributeId).hide();
                                },1000);
                            });
                            jQuery('.attributeInfoImg'+attributeInfo.attributeId).hover(function(){
                                clearTimeout(setNull);
                            },function(){
                                setNull = setTimeout(function(){
                                    jQuery('.attributeInfoImg'+attributeInfo.attributeId).hide();
                                },1000);
                            },1000);
                        },1000);
                    }else{
                        htm = '<div class="attributeInfoImg"><label title="上传'+attributeInfo.attributeName+'" class="lee-upload-fileicon l-icon-upload-big" for="fileId'+attributeInfo.attributeId+'">'+
                        '<i class="el-icon-circle-plus-outline" style=""></i><br/>上传图片'+
                        '</label><input type="file" id="fileId'+attributeInfo.attributeId+'" class="avatar-input">'+
                        '<input type="hidden" name="'+attributeInfo.attributeId+'"><div>';
                    }
                    this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);

                    //延时绑定 上传
                    var this_ = this;
                    setTimeout(function(){
                        jQuery(".attributeInfoImg").parent().css("position","relative");
                        jQuery("#fileId"+attributeInfo.attributeId).change(function(){
                            var fd = new FormData(),this1_ = this,
                            attributeId = jQuery(this1_).attr("id").replace("fileId","");
                            // 将用户选择的文件，添加到 FormData 中
                            fd.append('file', this.files[0])
                            var xhr = new XMLHttpRequest();
                            let token = this_.$getCookieForRoleTag();
                            xhr.open('POST', this_.uploadUrl);
                            xhr.setRequestHeader('token', token);
                            xhr.onload = function () {
                                if(xhr.status === 200){ //成功！
                                    let ret = JSON.parse(xhr.response); //返回值
                                    if(ret.code == 0){
                                        jQuery("input[name='"+attributeId+"']").val(ret.data.url);
                                        jQuery(this1_).parent().parent().find("img").remove();
                                        jQuery(this1_).parent().parent().prepend("<img class='img"+attributeId+"' style='width: 90%;height: auto;margin:0 auto;display:block;' src='"+this_.$isHttp(ret.data.url)+"' />")
                                        jQuery('.attributeInfoImg'+attributeId).hide();
                                        var setNull = null;
                                        jQuery('.img'+attributeId).hover(function(){
                                            if(setNull != null){
                                               clearTimeout(setNull);
                                            }
                                            jQuery('.attributeInfoImg'+attributeId).show();
                                        },function(){
                                            setNull = setTimeout(function(){
                                                jQuery('.attributeInfoImg'+attributeId).hide();
                                            },1000);
                                        });
                                        jQuery('.img'+attributeId).parent().find(".attributeInfoImg").hover(function(){
                                            clearTimeout(setNull);
                                        },function(){
                                            setNull = setTimeout(function(){
                                                jQuery('.attributeInfoImg'+attributeId).hide();
                                            },1000);
                                        },1000);
                                    }
                                }
                            };
                            xhr.send(fd);
                        });
                    },1000);
                }else if(attributeInfo.inputType == 7){ //多行输入类型

                    let htm = "";
                    let limitCondition = {minNumber:null,maxNumber:400};
                    if(attributeInfo.limitCondition != null && attributeInfo.limitCondition != ""){
                        limitCondition = JSON.parse(attributeInfo.limitCondition);
                        if(limitCondition.minNumber == 0){
                            limitCondition.minNumber = null;
                        }
                        if(limitCondition.maxNumber == 0){
                            limitCondition.maxNumber = 400;
                        }
                    }
                    if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                        htm = "<textarea class='attrEditInfo7 textareaClass' minlength='"+limitCondition.minNumber+"' maxlength='"+limitCondition.maxNumber+"' notNullStatus='"+attributeInfo.notNullStatus+"' title='请输入"+attributeName+"' placeholder='"+(attributeInfo.desc || "请输入"+attributeName)+"，只能输入400字' name='"+attributeInfo.attributeId+"'>"+attributeInfo.attributeRelation.value+"</textarea>";
                    }else{
                        htm = "<textarea class='attrEditInfo7 textareaClass' minlength='"+limitCondition.minNumber+"' maxlength='"+limitCondition.maxNumber+"' notNullStatus='"+attributeInfo.notNullStatus+"' title='请输入"+attributeName+"' placeholder='"+(attributeInfo.desc || "请输入"+attributeName)+"，只能输入400字' name='"+attributeInfo.attributeId+"'></textarea>";
                    }
                    this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                }else if(attributeInfo.inputType == 8){ //日期类型
                    let htm = "";
                    if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                        htm = "<input readonly class='attrEditInfo8 dataClassInfo' notNullStatus='"+attributeInfo.notNullStatus+"' title='请选择"+attributeName+"' placeholder='"+(attributeInfo.desc || "请选择"+attributeName)+"' id='test"+attributeInfo.attributeId+"' name='"+attributeInfo.attributeId+"' value='"+attributeInfo.attributeRelation.value+"' />";
                    }else{
                        htm = "<input readonly class='attrEditInfo8 dataClassInfo' notNullStatus='"+attributeInfo.notNullStatus+"' title='请选择"+attributeName+"' placeholder='"+(attributeInfo.desc || "请选择"+attributeName)+"' id='test"+attributeInfo.attributeId+"' name='"+attributeInfo.attributeId+"' />";
                    }
                    this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);

                    setTimeout(function(){
                        jQuery("#test"+attributeInfo.attributeId).datetime({
                            type:"date",
                            success:function(res){
                                console.log(res)
                            }
                        });

                    },1000);
                }else if(attributeInfo.inputType == 9){ //签名
                    let htm = "";
                    if(!this.$isEmpty(attributeInfo.attributeRelation) && !this.$isEmpty(attributeInfo.attributeRelation.value)){
                        htm = "<span id='attributeId"+attributeInfo.attributeId+"' notNullStatus='"+attributeInfo.notNullStatus+"'>"+attributeInfo.attributeRelation.value+"</span>";
                    }else{
                        htm = "<span id='attributeId"+attributeInfo.attributeId+"' notNullStatus='"+attributeInfo.notNullStatus+"'></span>";
                    }
                    this.signList.push({
                        attributeId:attributeInfo.attributeId
                    });
                    this.htmlInfo = this.htmlInfo.replace(editArray[i],htm);
                }
            }
        },
        /**
         * @param {Object} valList //需要遍历的list
         * @param {Object} onValue 选中值 |||隔开
         * @param {Object} attributeId //最外层 属性ID
         * @param {Object} htm 拼接好的html
         * @param {Object} key 显示的位置
         * @param {Object} count 遍历的次数 可用于当前点击的第几个select
         */
        getErgodicInfo(valList,onValue,attributeId,htm,key,count = 0){
            let htmOn = "<option value='"+count+'_'+"'>请选择</option>",i = 0;
            if(!this.$isEmpty(onValue)){ //不为空时 需要返现
                for(let inx in valList){
                    if(!this.$isEmpty(onValue) && ("|||"+onValue+"|||").indexOf("|||"+valList[inx].attributeName+"|||") >= 0){
                        i = inx;
                        htmOn += "<option selected value='"+count+'_'+inx+"'>"+valList[inx].attributeName+"</option>";
                    }else{
                        htmOn += "<option value='"+count+'_'+inx+"'>"+valList[inx].attributeName+"</option>";
                    }
                }
            }else{
                if(this.$isEmpty(htm)){
                    for(let inx in valList){
                        htmOn += "<option value='"+count+'_'+inx+"'>"+valList[inx].attributeName+"</option>";
                    }
                }
            }
            htm += "<div class='select'><select class='attrEditInfo4 selectInput4' index='"+count+"' name='"+attributeId+"'>"+htmOn+"</select></div>";
            if(!this.$isEmpty(valList[i].children) && valList[i].children.length > 0){
                count ++;
                this.getErgodicInfo(valList[i].children,onValue,attributeId,htm,key,count);
            }else{
                this.htmlInfo = this.htmlInfo.replace(key,htm); //替换html


                //选择下拉联动
                setTimeout(()=>{ //绑定事件
                    let this_ = this;
                    jQuery("select[name='"+attributeId+"']").change(function(){
                        let positionVal = jQuery(this).val().split("_"); //拿到位置值0_1 0表示列数，1表示第几行
                        let idInfo = jQuery(this).attr("name");//拿到属性ID，根据属性ID获取list数据
                        let allList = this_.allInputType4[idInfo];
                        jQuery("select[name='"+idInfo+"']").each(function(n,k){ //所有的该ID关联select
                            if(positionVal[1] == null || positionVal[1] == ""){
                                jQuery("select[name='"+idInfo+"']:eq("+(n+1)+")").html("<option value='"+(n+1)+'_'+"'>请选择</option>");
                            }else{
                                let l = jQuery(this).val().split("_"); //位置信息
                                allList = allList[l[1]].children; //拿到最后哦一个值
                                if(n == Number(positionVal[0])){
                                    let htmLast = "<option value='"+(n+1)+'_'+"'>请选择</option>";
                                    for(let inx in allList){
                                        htmLast += "<option value='"+(n+1)+'_'+inx+"'>"+allList[inx].attributeName+"</option>";
                                    }
                                    jQuery("select[name='"+idInfo+"']:eq("+(n+1)+")").html(htmLast);
                                    return false;
                                }
                            }
                        });
                    });
                    jQuery("select[name='"+attributeId+"']:last").unbind(); //取消最后一个的联动
                },200);
            }
        },
        saveInfo(){ //保存模板数据
            let param = this.getParamInfo();
            if(param ==false){ //存在未填写的值
              return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/saveEditTemplateData",param).then((ret) => {
                loading.close();
                if(ret.code == 0){
                    this.$message.success(ret.msg);
                }else{
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
                loading.close();
            });
        },
        getParamInfo(){ //获取各种类型的参数信息
            let attributeRelationList = [];//{attributeIds:"属性ID",value:"学生填写的值多选（,）联动|||"}
            let isNot = true; //
            for(let item in this.getParamKey){
                let v = "";
                if(this.getParamKey[item] == 1){ //1单选 2多选 3输入 4多级联动  5上传图片 6上传附件 7多行输入 8日期
                    v = jQuery("select[name='"+item+"']").val();
                    if(this.$isEmpty(v) && jQuery("select[name='"+item+"']").attr('notNullStatus') == 1){ //不能为空
                        this.$message.warning(jQuery("select[name='"+item+"']").attr('title'));
                        isNot = false;
                        break;
                    }
                }else if(this.getParamKey[item] == 2){
                    jQuery("input[name='"+item+"']:checked").each(function(i){
                        v += jQuery(this).val();
                        if(i < jQuery("input[name='"+item+"']:checked").length - 1){
                            v += ",";
                        }
                    });
                    if(this.$isEmpty(v) && jQuery("input[name='"+item+"']").attr('notNullStatus') == 1){ //不能为空
                        this.$message.warning(jQuery("input[name='"+item+"']").attr('title'));
                        isNot = false;
                        break;
                    }
                }else if(this.getParamKey[item] == 3){
                    v = jQuery("input[name='"+item+"']").val();
                    if(this.$isEmpty(v) && jQuery("input[name='"+item+"']").attr('notNullStatus') == 1){ //不能为空
                        this.$message.warning(jQuery("input[name='"+item+"']").attr('title'));
                        isNot = false;
                        break;
                    }
                    var minlength = jQuery("input[name='"+item+"']").attr('minlength');
                    if(!this.$isEmpty(minlength) && minlength > v.length){
                        this.$message.warning(jQuery("input[name='"+item+"']").attr('title').replace("请输入","") +"最少输入"+minlength+"字");
                        isNot = false;
                        break;
                    }
                }else if(this.getParamKey[item] == 4){
                    jQuery("select[name='"+item+"']").each(function(i){
                        v += jQuery(this).find("option:selected").text();
                        if(i < jQuery("select[name='"+item+"']").length - 1){
                            v += "|||";
                        }
                    });
                }else if(this.getParamKey[item] == 5){
                    v = jQuery("input[name='"+item+"']").val();
                }else if(this.getParamKey[item] == 7){
                    v = jQuery("textarea[name='"+item+"']").val();
                    if(this.$isEmpty(v) && jQuery("textarea[name='"+item+"']").attr('notNullStatus') == 1){ //不能为空
                        this.$message.warning(jQuery("textarea[name='"+item+"']").attr('title'));
                        isNot = false;
                        break;
                    }
                    var minlength = jQuery("textarea[name='"+item+"']").attr('minlength');
                    if(!this.$isEmpty(minlength) && minlength > v.length){
                        this.$message.warning(jQuery("textarea[name='"+item+"']").attr('title').replace("请输入","") +"最少输入"+minlength+"字");
                        isNot = false;
                        break;
                    }
                }else if(this.getParamKey[item] == 8){
                    v = jQuery("input[name='"+item+"']").val();
                    if(this.$isEmpty(v) && jQuery("input[name='"+item+"']").attr('notNullStatus') == 1){ //不能为空
                        this.$message.warning(jQuery("input[name='"+item+"']").attr('title'));
                        isNot = false;
                        break;
                    }
                }else if(this.getParamKey[item] == 9){
                    v = jQuery("#attributeId"+item).html();
                    if(this.$isEmpty(v) && jQuery("#attributeId"+item).attr('notNullStatus') == 1){ //不能为空
                        this.$message.warning("签名不能为空！");
                        isNot = false;
                        break;
                    }
                }

                attributeRelationList.push({attributeIds:item,value:v || ""});
                // if(!this.$isEmpty(v)){
                //     attributeRelationList.push({attributeIds:item,value:v});
                // }
            }
            if(isNot){
                return {
                    attributeRelationList:attributeRelationList,
                    templateId:this.templateId
                };
            }else{
                return isNot;
            }
        },
        getInfo(){ //获取table类型
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/useTableTemplate",{templateName:this.templateName}).then((ret) => {
                loading.close();
                if(ret.code == 0){
                    this.currentType = 1;
                    this.dataInfo = ret.studentTemplate;
                    if(ret.data.length > 0){
                        this.htmlInfo = ret.data[0];
                    }else{
                        this.$message({message: "生成失败！",type:"warning"});
                    }
                }else{
                  this.$message({message: ret.msg,type: "warning"});
                }
            }).catch((err) => {
                loading.close();
            });
        },
        printNow() { // 转图片打印
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            html2canvas(this.$refs.printContent,{
                allowTaint: false,
                useCORS: true,
                height: this.$refs.printContent.outerHeight,
                width: this.$refs.printContent.outerWidth,
                windowWidth: document.body.scrollWidth,
                windowHeight: document.body.scrollHeight,
            }).then((canvas) => {
                loading.close();
                // let url = canvas.toDataURL('image/jpeg', 1.0)
                const url = canvas.toDataURL();
                // const style = '@page {margin:0 10mm};'//打印时去掉眉页眉尾
                printJS({
                  printable: url,
                  type: 'image',
                  header: '',
                  style: `@media print { @page {size: auto;} body{margin:0}}`,
                  documentTitle: this.templateName || '我的信息打印',
                  targetStyles: ['*'],
                  // style
                });
            }).catch((err) => {
                loading.close();
            });
        },
        printNowImg(){ //打印图片类型
            //打印为什么要去掉眉页眉尾？因为眉页title时打印当前页面的title，相当于是获取html中title标签里面的内容，但是比如我打印的内容只是一个弹框里面的内容，是没有title的，这时候就会出现undefined，为了避免出现这种情况，就可以隐藏眉页眉尾
            // printJS({
            //     printable: this.$isHttp(this.imgUrlList[0]),// 标签元素id
            //     type: 'image',
            //     header: null,
            //     targetStyles: ['*'],
            //     style
            // });
            //判断图片是横屏还是竖屏，动态设置宽高，进行打印
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            var img = new Image();
            img.src = this.$isHttp(this.imgUrlList[0]);
            img.onload = ()=> {
                var realWidth = img.width;  // 真实宽度
                var realHeight = img.height; // 真实高度
                var outerHTML = ""; // 内容
                var style =  '@media print { @page {size: auto; margin: 0; } body{margin:0 0}}'//打印时去掉眉页眉尾
                if (realWidth > realHeight){ //横屏
                    style = '@media print { @page {size: landscape; margin: 0; } body{margin:0 0}}'//打印时去掉眉页眉尾
                    outerHTML = '<div style="text-align: center;display: flex;justify-content: center;align-items: center;height:794px;"><img src="'+this.$isHttp(this.imgUrlList[0])+'" style="max-width: 100%;max-height:794px; display: inline-block;"/></div>'
                }else{ //竖屏
                    style = '@media print { @page {size: portrait; margin: 0; } body{margin:0 0}}'//打印时去掉眉页眉尾
                    outerHTML = '<div style="text-align: center;display: flex;justify-content: center;align-items: center;height:1123px;"><img src="'+this.$isHttp(this.imgUrlList[0])+'" style="max-width: 100%;max-height:1123px; display: inline-block;"/></div>'
                }
                loading.close();
                printJS({
                    printable: outerHTML,// 标签元素id
                    type: 'raw-html',
                    header: null,
                    targetStyles: ['*'],
                    style
                });
            };

        },
        downImg(){ //导出IMG
            this.$downLoadFile(this.imgUrlList[0]);
        },
        downloadNow(){ //导出
            if(!this.$isEmpty(this.studentInfo.studentId)){
                this.$downLoadFile("/api/student/exportTableTemplateToPdf.do?templateName="+this.templateName+"&studentId="+this.studentInfo.studentId,this.studentInfo.studentName+"__"+this.templateName+".zip");
            }else{
                this.$message.warning("学生数据丢失！");
            }
        },
        getTemplateByName(){ //获取模板信息
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/getTemplateByName",{templateName:this.templateName}).then((ret) => {
                loading.close();
                if(ret.code == 0){
                    this.templateType = ret.data.templateType;
                    if(this.templateType == 2){
                        this.getInfo();
                    }else if(this.templateType == 1){
                        this.getUseImgTemplate();
                    }
                    if(ret.data.type == 2){
                        this.isEdit = true;
                    }
                }else{
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
                loading.close();
            });
        },
        getUseImgTemplate() { //获取图片类型
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/useImgTemplate", {templateName: this.templateName}).then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.imgUrlList = ret.data || [];
                } else {
                    this.$message({message: ret.msg, type: "warning"});
                }
            }).catch(err=>{
                loading.close();

            })
        },
        seeRemark(){ //查看备注
            this.$notify.error({
              title: '审核未通过原因',
              position: 'bottom-right',
              duration:60000,
              message: this.dataInfo.studentTemplateExamineRemark
            });
        },
        singShow(item){
            this.visible = true;
            this.onAttributeId = item.attributeId;
        },
        signStart(){ //本人签名
            this.visible = false;
            this.visible_sign = true;
        },
        closeMsg(){
            this.visible_sign = false;
        },
        saveSignValue(data){ //签名的url地址
            jquery("#attributeId"+this.onAttributeId).html('<img style="width: 200px;height: 100px;" src="'+this.$isHttp(data)+'">');
        },
        creatQRCode(){
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let urlParm = window.configs.API_ROOT;//.replace("http","xxxx").replace("//","a_a").replace(/:/g,"axa").replace("/","c_c");
            const url = "http://ggk.cj-edu.com/h5/pages/studentInfo/userInfoScanCode?attributeId="+this.onAttributeId+"&tInfo="+getCookieForRoleTag()+"&url="+urlParm+"&templateId="+this.templateId;//window.configs.API_ROOT
            this.$store.dispatch("user/creatQRCode", {data: url}).then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.qRcodeImg = this.$isHttp(ret.data);
                    this.visible = false;
                    this.visible_qRcode = true;
                } else {
                    this.$message({message: ret.msg, type: "warning"});
                }
            }).catch(err=>{
                loading.close();

            })
        },
        getSignInfo(){ //手动获取手机端是否已经签名
            this.signLoading = true;
            this.$store.dispatch("user/getAttributeRelation", {attributeId:this.onAttributeId,typeId:this.studentInfo.studentId}).then((ret) => {
                this.signLoading = false;
                if (ret.code == 0) {
                    if(ret.data != null && ret.data != '' && ret.data.value != null && ret.data.value != ""){
                        jQuery("#attributeId"+this.onAttributeId).html(ret.data.value);
                        this.visible_qRcode = false;
                        this.$message({message: '签名成功！', type: "success"});
                    }else{
                        this.$message({message: '未获取到签名，请扫码进行签名！', type: "warning"});
                    }
                } else {
                    this.$message({message: ret.msg, type: "warning"});
                }
            }).catch(err=>{
                this.signLoading = false;
            })

        }
    }
};
</script>
<style src="../static/date/dateTime.scss"></style>
<style lang="less">
    @import '../styles/base.less';
    .templateEdit{
        padding-top: 50px;
        .select {
            display: inline-block;
            width: 100%;
            position: relative;
            vertical-align: middle;
            padding: 0;
            overflow: hidden;
            background-color: #fff;
            color: #555;
            border: 1px solid #aaa;
            text-shadow: none;
            border-radius: 4px;
            transition: box-shadow 0.25s ease;
            z-index: 2;
        }

        .select:hover {
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
        }

        .select:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 10px solid transparent;
            border-top-color: #ccc;
            top: 14px;
            right: 10px;
            cursor: pointer;
            z-index: -2;
        }
        .select select {
            cursor: pointer;
            padding: 10px;
            width: 100%;
            border: none;
            background: transparent;
            background-image: none;
            -webkit-appearance: none;
            -moz-appearance: none;
        }
        .select select option{
            padding: 20px 100px !important;
            min-height: 50px;
            white-space: initial;
            font-size: 18px;
            border: none;
        }
        .select select:focus,.inputClass:focus,.textareaClass:focus,.dataClassInfo:focus {
            outline: none;
        }

        .inputClass{
            padding: 10px;
            border-radius: 5px;
            border: 1px solid #aaa;
            width: calc(100% - 20px);
        }

        .textareaClass {
            padding: 10px;
            border-radius: 5px;
            border: 1px solid #aaa;
            width: calc(100% - 20px);
            min-height: 200px;
        }

        .checkboxClass{
            margin-right: 10px;
            float: left;
        }
        .checkboxClass input{
            margin-right: 10px;
        }
        .checkboxClass input,.checkboxClass label{
            cursor: pointer;
        }
        .dataClassInfo{
            border: 1px solid #aaa;
            border-radius: 5px;
            width: calc(100% - 20px);
            padding: 10px;
        }

        #printBill{
            width: 1060px;
            table{
                width: 100% !important;
                tr{
                    page-break-inside: avoid; //避免打印被截断
                }
            }
        }
        .but{
            font-size: 18px;
            border-color:@bgZS;
            color:@bgZS;
            padding:8px 10px;
        }
        .avatar-input{
            display: none;
        }
        .lee-upload-fileicon{
            cursor: pointer;
            color:@bgZS;
            display: block;
            width: 80%;
            margin-left: 10%;
        }
        .attributeInfoImg{
            position: absolute;
            text-align: center;
            width: 100%;
            left: 0;
            top: calc(50% - 25px);
        }
        .attributeInfoImg:hover{
            .lee-upload-fileicon{
                border: 1px dotted @bgZS;
                width: calc(80% - 2px);
                height: 37px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/templateEdit.vue